import * as R from 'ramda';
import { Endpoints } from '../../../core/api/endpoints';
import { ApiReducer, makeApiReducer, makeApiAction, makeRsaaTypes } from '../../../core/api/rsaa';
import { addError, noLoadingNoError, addLoading, getLoading } from '../../../core/api/module';
import { ActionType } from '../../../core/redux/actionType';
import { DevPlanItem } from '../models';


const KEY_ACTION = ActionType.AddDevPlanItemRequest;
const ACTIONS    = [
  ActionType.AddDevPlanItemRequest,
  ActionType.AddDevPlanItemResponse,
  ActionType.AddDevPlanItemError,
];


type Payload = DevPlanItem;

type Meta = {
  projectId: number;
  participantId: number;
};


/**
 * Dispatch this action to add a dev plan item
 */
export const addDevPlanItemAction = (
  participantId: number,
  projectId: number,
  competencyId: number,
  itemName: string | undefined,
) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.AddDevPlanItem,
  headers:  { 'content-type': 'application/json' },
  body:     state => JSON.stringify({
    participantId: participantId,
    languageId:    state.locale.lang.languageId,
    projectId:     projectId,
    competencyId:  competencyId,
    itemName:      itemName,
  }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { projectId, participantId }),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  if (!payload) {
    return successState;
  }

  return R.assocPath(
    ['devPlan', 'items'],
    (successState.devPlan?.items || []).concat(payload),
    successState,
  );
};


export const addDevPlanItemReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
